import React from 'react';
import classnames from 'classnames';
import { ButtonProps } from './types';
import s from './index.module.scss';

export const Button = ({
  type,
  label,
  theme = 'brand',
  appearance = 'filled',
  size = 'xl',
  iconLead = false,
  iconTrail = false,
  iconUrl,
  disabled,
  children,
  className,
  ...nativeButtonProps
}: ButtonProps) => {
  let content;

  if (label) {
    content = <span className={s.label}>{label}</span>;
  }

  if (iconUrl) {
    content = <img src={iconUrl} alt="icon" />;
  }

  if (children) {
    content = children;
  }

  return (
    <button
      disabled={disabled}
      type={type || 'button'}
      className={classnames(
        s.button,
        `size_${size}`,
        `type_${theme}`,
        `appearance_${appearance}`,
        iconUrl && 'icon_only',
        iconLead && 'icon_lead',
        iconTrail && 'icon_trail',
        className
      )}
      {...nativeButtonProps}
    >
      {content}
    </button>
  );
};